import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { TimePicker } from '../index';
import styles from '../styles/styles.js';
import useFormikSchema from '../hooks/useFormikSchema';
import { formatErrorWithIcon } from '../utils/formatError';
const { makeStyles } = styles;

const FormikTimePicker = props => {
  const classes = useStyles();
  const { label, value, name, format, valueFormat, disabled, pickerProps, schema, ...rest } = props;
  const dataTestId = props['data-testid'];
  const { formattedLabel } = useFormikSchema(name, label, schema);
  return (
    <div className={classes.dateContainer}>
      <Field
        disabled={disabled}
        value={value}
        name={name}
        component={
          ({ field, form, meta }) => {
            const error = form.errors[field.name];
            const handleDateChange = (dateMoment) => {
              console.log('handleDateChange', dateMoment);
              form.setFieldValue(name, dateMoment);
            };
            return (
              <TimePicker
                data-testid={dataTestId}
                {...rest}
                {...pickerProps}
                disabled={disabled}
                value={field.value}
                format={format}
                valueFormat={valueFormat}
                error={formatErrorWithIcon(error)}
                label={formattedLabel}
                onChange={handleDateChange}
                name={field.name} />
            )
          }
        } />
    </div>
  );
};

FormikTimePicker.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  format: PropTypes.string,
  valueFormat: PropTypes.string,
  pickerProps: PropTypes.object,
  minDate: PropTypes.any,
  maxDate: PropTypes.any,
};



const useStyles = makeStyles(theme => ({
  dateContainer: {
    position: 'relative',
  },
}));

export default FormikTimePicker;
